import React from 'react';
import { Container } from 'react-bootstrap';
import Slider from 'react-slick';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import ProductCard from './ProductCard';

const newArrivalProducts = [
  { id: 21, name: 'Hangerie\n(Product 15) Sample', price: 615.95, imageSrc: '/img/_91A6083.JPG', rating: 5, colors: [], isNew: true },
  { id: 22, name: 'Able Brewing\n(Product 14) Sample', price: 517.00, imageSrc: '/img/_91A5294.JPG', rating: 0, colors: [], isNew: true },
  { id: 23, name: 'Red Lingerie Set', price: 345.00, imageSrc: '/img/_91A6188.JPG', rating: 4, colors: [], isNew: true },
  { id: 24, name: 'Black Lace Set', price: 299.00, imageSrc: '/img/_91A5342.JPG', rating: 5, colors: [], isNew: true },
];

const NewArrival = ({ onAddToCart }) => {
  const sliderRef = React.useRef(null);
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="py-5 newArrivalBg">
      <Container>
        <div className="position-relative">
          <Slider ref={sliderRef} {...sliderSettings}>
            {newArrivalProducts.map((product) => (
              <div key={product.id} className="px-2">
                <ProductCard product={product} onAddToCart={onAddToCart} />
              </div>
            ))}
          </Slider>
          <div className="d-flex justify-content-center align-items-center mt-4">
            <button type="button" className="btn" onClick={() => sliderRef.current?.slickPrev()}>
              <FiChevronLeft size={24} />
            </button>
            <a href="#collections" className="text-dark fw-bold text-decoration-none mx-3">
              SHOP THE COLLECTION
            </a>
            <button type="button" className="btn" onClick={() => sliderRef.current?.slickNext()}>
              <FiChevronRight size={24} />
            </button>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default NewArrival;
